import type { AssessmentResultData } from '@ts-assessment/interfaces'

import { useAssessmentResultStore } from '@stores/assessment-result'

import { useAssessmentResultApi } from '@api/assessments-result/assessments-result.hook'
import { useAssessmentResult } from '@hooks/assessments-result/assessment-results.hook'

interface AssessmentResultLoadReturn {
  load: (assessmentId: number) => Promise<void>
}

export const useAssessmentResultLoad = (): AssessmentResultLoadReturn => {
  const assessmentResultStore = useAssessmentResultStore()
  const { initAssessmentResult } = useAssessmentResult()

  const load = async (assessmentId: number): Promise<void> => {
    const requestId = assessmentResultStore.begin(assessmentId)
    const isSuperseded = (): boolean => requestId !== assessmentResultStore.requestId

    await useAssessmentResultApi({
      params: { assessment: String(assessmentId) },
    }, {
      onSuccess: (data: AssessmentResultData) => {
        if (isSuperseded()) return

        initAssessmentResult(data)
        assessmentResultStore.settle(assessmentId, requestId)
      },
      onError: () => assessmentResultStore.fail(assessmentId, requestId),
    })
  }

  return { load }
}
